import { AlertSnippetDto } from '../../interfaces/IEvent'
import { AlertSendStatus } from '../../interfaces/IAlert'

export interface AlertFilterOption {
  id: string
  label: string
}

export type FilterMode = 'received' | 'notReceived'

const statusLabelMap: Partial<Record<string, string>> = {
  [AlertSendStatus.Sent]: 'sendt',
  [AlertSendStatus.SentPartially]: 'delvis sendt',
  [AlertSendStatus.Draft]: 'utkast',
  [AlertSendStatus.NotProcessed]: 'ventende',
  [AlertSendStatus.Processing]: 'sender',
  [AlertSendStatus.FailedBeforeSend]: 'feilet',
}

export function buildAlertFilterOptions(alerts: AlertSnippetDto[] | undefined): AlertFilterOption[] {
  if (!alerts) return []
  const relevantAlerts = alerts.filter((a) => a.notifiedCustomers)
  const baseLabelCounts = new Map<string, number>()
  relevantAlerts.forEach((a) => {
    const base = a.description || a.id
    baseLabelCounts.set(base, (baseLabelCounts.get(base) ?? 0) + 1)
  })
  return relevantAlerts.map((a) => {
    const base = a.description || a.id
    const needsDisambiguation = (baseLabelCounts.get(base) ?? 0) > 1
    const statusText = statusLabelMap[a.status] ?? a.status
    const parts: string[] = [statusText]
    if (needsDisambiguation && a.sendOn) {
      const d = new Date(a.sendOn)
      if (!isNaN(d.getTime())) {
        parts.push(d.toLocaleString('nb-NO', {
          day: '2-digit',
          month: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        }))
      }
    }
    return { id: a.id, label: `${base} (${parts.join(', ')})` }
  })
}

export function filterCustomersByAlerts(
  customerAlertHistory: Map<string, AlertSnippetDto[]>,
  selectedAlertIds: string[],
  mode: FilterMode,
  allIds: string[],
): Set<string> {
  if (selectedAlertIds.length === 0) return new Set(allIds)

  if (mode === 'received') {
    return new Set(
      allIds.filter((id) => {
        const alerts = customerAlertHistory.get(id) ?? []
        return alerts.some((a) => selectedAlertIds.includes(a.id))
      }),
    )
  }

  return new Set(
    allIds.filter((id) => {
      const alerts = customerAlertHistory.get(id) ?? []
      return !alerts.some((a) => selectedAlertIds.includes(a.id))
    }),
  )
}
